









































































































































































import {Component} from 'vue-property-decorator';
import {CardForm} from '@/components/bwaff';
import Form, {Send} from '@/components/form-base';
import Api from '@/services';
import UiSelectLanguage from '@/components/ui/ui-select-language.vue';
import VueRecaptcha from 'vue-recaptcha';
import {mixins} from 'vue-class-component';
import Recaptcha from '@/views/pages/mixins/recaptcha-mixin.vue';
import store from '@/store';

@Component({
  components: {
    CardForm,
    UiSelectLanguage,
    VueRecaptcha
  }
})
export default class Login extends mixins<Recaptcha,Form>(Recaptcha,Form) {
  error: boolean = false;
  error_message: string = '';
  edit: boolean = true;
  saved: boolean = false;
  success: boolean = false;
  show_password: boolean = false;
  email: string = '';
  password: string = '';
  tokenExpired: boolean = false;

  get self() {
    return this;
  }

  get userId() {
    return this.$route.query.accountId as string;
  }

  created() {
    const {t} = (this as any);
    const $on = this.$on.bind(this);

    $on('error:400', () => {
      this.error = true;
      this.error_message = t('Wrong email');
    });

    $on('error:401', () => {
      this.error = true;
      this.error_message = t('Your password recovery link is expired');
      this.tokenExpired = true;
    });

    $on('error:403', () => {
      this.error = true;
      this.error_message = t('Your password recovery link is expired');
    });
  }

  get fromEmail() {
    return this.$route.query.code && this.$route.query.uid;
  }

  redirectToForgotPassword() {
    this.success = false;
    this.error = false;
    this.tokenExpired = false;

    this.$router.push({
      name: 'forgot-password'
    });
  }

  redirectToLogin() {
    const url = this.userId
    ? {
        path: '/login/member',
        query: {
          accountId:this.userId
        }
      }
    : '/login'
    this.$router.push(url);
  }

  @Send()
  submit() {
    return Api.forgotPassword({
      email: this.email,
      password: this.password,
      recaptchaResponse: this.recaptchaResponse,
      ...(this.userId && {userId : this.userId})
    }).then(() => {
      this.saved = true;
      this.success = true;
    });
  }

  @Send()
  async submitNewPassword() {
    try {
      await Api.loginExternal(this.$route.query.code as string);
      await Api.userApi.putForgotPasswordSetNew({
        email: this.email,
        password: this.password
      });

      Api.removeAuthToken();
      this.redirectToLogin();

      return Promise.resolve();
    } catch(error) {
      return Promise.reject(error);
    }
  }
}
